<template>
  <div id="RatingView">
    <!-- === HEADER SUPERIOR === -->
    <TopPanel
      :tabs="[
        { label: 'Caracterización', path: '/caracterizacion/' },
        { label: 'Rating', path: '/rating/' },
        { label: 'Materia prima', path: '/materiaprima/' }
      ]"
      @year-changed="onYearChanged"
    />
    <!-- === CUERPO PRINCIPAL === -->
    <v-card class="px-3 py-3" id="body-raiting">
            <h1 class="gray-font-title">Rating</h1>
            <p class="gray-font-subtitle">Productores</p>
            <span class="gray-font-text">Buenas Prácticas Sostenibilidad Agrícola</span>
            
            <div class="text-center">
              <div class="image-container"
                  :key="selectedYear"
                  :style="{ 
                    backgroundImage: `url(${ratingImage})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat'
                  }">
              </div>
            <p class="gray-font-text">
              BPSA: Buenas Prácticas Sostenibilidad Agrícola
            </p>
          </div>
      </v-card>
    </div>
  </template>
  
  <script>
  import { mapState, mapGetters } from 'vuex';
  import YearPicker from '@/components/YearPicker.vue';
  import { mockData } from '@/data/mockData.js';
  import TopPanel from "@/components/layout/TopPanel.vue";
  


  export default {
    name: 'RatingView',
    components: {
      YearPicker,TopPanel,
    },

    data() {
      return {
        activeTab: 1,
        tabs: [
          { label: 'Caracterización', path: '/caracterizacion/' },
          { label: 'Rating', path: '/rating/' },
          { label: 'Materia Prima', path: '/materiaprima/' },
        ],
      };
    },

    computed: {
      ...mapState(['selectedYear']),
      ...mapGetters(['availableYears']),
      
      currentYearData() {
       return mockData[this.selectedYear] || mockData['2024'] || { resultados: {} };
      },
      ratingImage() {
        // lee desde resultados.rating.image y aplica fallback
        const img = this.currentYearData?.resultados?.rating?.image
        return img || require('@/media/rating_E-adjust.png')

    },
    },
    methods:{
      navigateTo(index) {
        this.activeTab = index;
        this.$router.push({ path: this.tabs[index].path });
      },
      onYearChanged(newYear) {
        console.log(`📅 Cambio de año en Rating: ${newYear}`);
        this.$store.commit('setSelectedYear', newYear);
        this.$store.dispatch('hydrateProducersByYear', newYear);
        //this.$store.commit('setSelectedProducer', null);
      },
    },
  };
  </script>
  
<style scoped>
  #RatingView {
    /* Asegura que ocupe toda la altura del viewport */
    min-height: 100vh; 
    /* Usa Flexbox para organizar el header y el body */
    display: flex;
    flex-direction: column;
    /* Elimina el scroll del componente si es innecesario */
    overflow: hidden; 
  }

  #body-raiting {
    /* Permite que crezca para ocupar el espacio restante (header ya está) */
    flex: 1; 
    /* Asegura que el contenido interno de la tarjeta (como el image-container) no cause scroll */
    overflow-y: hidden; 
    /* CLAVE: Agrega Flexbox a la tarjeta para manejar sus hijos verticalmente */
    display: flex;
    flex-direction: column; 
    /*padding: 1rem; /* Reemplaza el padding fijo de v-card */
  }
  .v-btn.white--text {
    background-color: white;
    color: black !important;
  }
  .image-container {
    flex: 1; /* Nuevo: Permite que tome el espacio disponible */
    display: flex;
    flex-direction: column;
    min-height: 200px; /* Tamaño mínimo aceptable */
    /* Elimina el height: 49vh; original */
  }
 
  /* CLASE PARA "Rating" (la más grande) */
  .gray-font-title {
    color: #7F7F7F;
    /* Hacemos el título más grande, usando una fuente responsive grande */
    font-size: clamp(1.8rem, 2.8vw, 3.5rem);
    font-weight: bold;
    text-align: left; /* Asegura la alineación */
    margin-bottom: 0.5rem; /* Añade un pequeño espacio debajo */
  }

  /* CLASE PARA "Productores" (mediana) */
  .gray-font-subtitle {
    color: #7F7F7F;
    /* Tamaño mediano */
    font-size: clamp(1.2rem, 1.8vw, 2.5rem);
    font-weight: normal;
    text-align: left; /* Asegura la alineación */
    margin-top: 0;
    margin-bottom: 0.5rem;
  }
  /* CLASE PARA "Buenas Prácticas" y otros textos pequeños */
  .gray-font-text { 
    color: #7F7F7F;
    /* Tamaño más pequeño y fijo para el detalle */
    font-size: 1.1rem; /* Aproximadamente 17.6px, más pequeño que los títulos */
    font-weight: normal;
    display: block; /* Asegura que el <span> o <p> ocupe su propia línea */
    margin-bottom: 0.5rem;
  }
  .gray-font-text-italic {
    font-style: italic;
  }
   .gray-font {
  color: #7F7F7F;
  font-size: clamp(0.95rem, 1vw, 1.1rem);
  text-align: left;
  }
  /* --- Header --- */
  .header-bar {
    display: flex;
    align-items: center;
  }

  .header-bar h2 {
    margin: 0;
    padding: 0;
    line-height: 40px;
    font-size: clamp(16px, 1.2vw, 22px);
  }
  /* ====== AJUSTES PARA PANTALLAS GRANDES (27" o más anchas) ====== */
  @media (min-width: 1600px) {
    /* Aumentar el tamaño de la imagen en monitores muy grandes para mejor balance */
    .image-container {
      /* Aseguramos una altura mínima mucho mayor. 
        Esto domina el 'flex: 1' y fuerza al contenedor a estirarse, 
        mejorando el balance visual. 
      */
      min-height: 550px; 
    }

    /* Opcional: Asegurar que el título principal sea realmente grande en pantallas grandes */
    .gray-font-title {
      font-size: 3.0rem; /* Forzar el tamaño máximo en pantallas anchas */
    }
  }
</style>